// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1GoAt","content":"ManualTimeModal_content__1vH0l"};